import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { websiteDetail } from "../utils/common.data";

const Footer = () => {
  const [addrressInfo, setAddrressInfo] = useState("");
  const [emailInfo, setEmailInfo] = useState("");
  const [phoneInfo, setPhoneInfo] = useState("");
  // const [logoURL, setLogoURL] = useState("");
  const [footerTitle, setFooterTitle] = useState("");
  const [footerDes, setFooterDes] = useState("");
  const [copyright, setCopyright] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Call the function to scroll to top when the component mounts

    // async function fetchData() {
    //   try {
    //     const response = await fetch(
    //       `${process.env.REACT_APP_STRAPI_API_URL}/api/footer-navbars?populate=*`
    //     );
    //     if (!response.ok) {
    //       throw new Error("Network response was not ok");
    //     }
    //     const data = await response.json();
    //     setAddrressInfo(data.data[1].attributes.ContactInfo[0].Value);
    //     setEmailInfo(data.data[1].attributes.ContactInfo[1].Value);
    //     setPhoneInfo(data.data[1].attributes.ContactInfo[2].Value);
    //     // setLogoURL(data.data[1].attributes.Logo.data.attributes.url);
    //     setFooterTitle(data.data[1].attributes.ContactInfo[3].Name);
    //     setFooterDes(data.data[1].attributes.ContactInfo[3].Value);
    //     setCopyright(data.data[1].attributes.ContactInfo[4].Value);
    //   } catch (error) {
    //     console.error("There was a problem fetching the data:", error);
    //   }
    // }

    // fetchData();

    handleScrollToTop();
  }, []);
  return (
    <>
      <section className="tj-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="about-widget widget">
                <h3>About {websiteDetail.titleValue}</h3>
                <p>
                  {websiteDetail.titleValue} is a global transportation app developed by 
                  {" "} {websiteDetail.developed}, a leading software company. Designed to
                  offer a seamless and sophisticated travel experience, {websiteDetail.titleValue} {" "}
                  connects users with reliable, convenient, and affordable rides
                  around the world.<br/><br/> Our app combines cutting-edge technology
                  with a commitment to excellence, ensuring every journey is
                  efficient, safe, and tailored to your needs. Whether
                  you&apos;re traveling for business, pleasure, or exploring new
                  destinations, {websiteDetail.titleValue} provides a superior transportation
                  experience that meets your expectations.<br/><br/> Discover the ease and
                  elegance of travel with {websiteDetail.titleValue}, powered by {websiteDetail.developed}.
                </p>
                <ul className="fsocial-links">
                  {process.env.REACT_APP_FACEBOOK_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_FACEBOOK_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                  )}
                  {process.env.REACT_APP_TWITTER_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_TWITTER_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                  )}

                  {process.env.REACT_APP_LINKED_IN_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_LINKED_IN_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  )}

                  {process.env.REACT_APP_PINTEREST_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_PINTEREST_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-pinterest-p"></i>
                      </a>
                    </li>
                  )}
                  {process.env.REACT_APP_INSTRAGRAM_URL && (
                    <li>
                      <a
                        href={process.env.REACT_APP_INSTRAGRAM_URL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <div className="col-md-3">
                          <div
                            className="links-widget widget"
                            style={{ marginBottom: "20px" }}
                          >
                            <h3>Quick Links</h3>
                            <ul className="flinks-list">
                                  <li>
                                    <i className="fas fa-info-circle"></i>
                                    <Link to="/about-us">About Us</Link>
                                  </li>
                                  <li>
                                    <i className="fas fa-briefcase"></i>
                                    <Link to="/services">Services</Link>
                                  </li>
                                  <li>
                                    <i className="fas fa-paper-plane"></i>
                                    <Link to="/contact-us">Contact Us</Link>
                                  </li>
                                  <li>
                                    <i className="fas fa-shield-alt"></i>
                                    <Link to="/privacy-policy">Privacy Policy</Link>
                                  </li>
                                  <li>
                                    <i className="fas fa-file-signature"></i>
                                    <Link to="/term-condition">Terms & Conditions</Link>
                                  </li>
                            </ul>
                          </div>
                        </div>

            <div className="col-md-4">
              <div className="contact-info widget">
                <h3>Contact Info</h3>
                <ul className="contact-box">
                  {/* <li>
                    <i className="fas fa-home" aria-hidden="true"></i>{" "}
                    {process.env.REACT_APP_BUSINESS_ADDRESS}
                  </li> */}
                  <li>
                    <i className="fas fa-home" aria-hidden="true"></i> {websiteDetail.addressData}{" "}
                  </li>
                  <li>
                    <i className="far fa-envelope-open"></i>
                    {/* <a href={`mailto:${process.env.REACT_APP_BUSINESS_EMAIL}`}>
                      {process.env.REACT_APP_BUSINESS_EMAIL}
                    </a> */}
                    <a href={`mailto:${websiteDetail.email}`}>
                      {websiteDetail.email}{" "}
                    </a>
                  </li>
                  <li>
                    <i className="fas fa-phone-square"></i>
                    <a href={`tel:${websiteDetail.countryCode}${websiteDetail.mobile}`}>{websiteDetail?.phoneNumber} </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--Footer Content End--> */}
      {/* <!--Footer Copyright Start--> */}
      <section className="tj-copyright">
        <div className="container" style={{ textAlign: "center" }}>
          <div className="">
            <div className="">
              <div>
                {/*     <p>
               {copyright}
              </p> */}
                <p style={{ textAlign: "center", float: "none", margin:'0', fontSize:'15px' }}>&copy; Copyrights {new Date().getFullYear()} {websiteDetail.titleValue}. All Rights Reserved.</p>
              </div>

              {/* <div
                className="priv-term privacy_term_main"
                style={{
                  cursor: "pointer",
                }}
              >
                <p
                  style={{ marginRight: "10px" }}
                >
                  <Link to="/term-condition">Terms & conditions</Link>
                </p>
                <p
                >
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Footer;
